import React from 'react';
import css from './quizDesign.module.css';
import { CheckIcon, ClockIcon, MicIcon } from './QuizIcons';
import { useTranslation } from 'react-i18next';

const QuizSidebar = ({ currentIndex, totalQuestions, results, score, quizType, onGoToQuestion }) => {
    const { t } = useTranslation();
    
    const answeredCount = results.filter(r => r !== undefined).length;
    const correctCount = results.filter(r => r === true).length;
    
    const dots = [];
    for (let i = 0; i < totalQuestions; i++) {
        let dotClass = css.sbQ;
        if (i === currentIndex) dotClass = css.sbQCurrent;
        else if (results[i] === true) dotClass = css.sbQOk;
        else if (results[i] === false) dotClass = css.sbQFail;
        
        const isAnswered = results[i] !== undefined;
        const isClickable = isAnswered && i !== currentIndex;
        
        dots.push(
            <div
                key={i}
                className={dotClass}
                style={isClickable ? { cursor: 'pointer' } : {}}
                onClick={() => isClickable && onGoToQuestion?.(i)}
                title={isClickable ? t('Review this question') : ''}
            >
                {i + 1}
            </div>
        );
    }

    return (
        <div className={css.sidebar}>
            <div className={css.sbCard}>
                <div className={css.sbTitle}>{t('Quiz progress')}</div>
                
                <div className={css.sbRow}>
                    <span className={css.sbLabel}>{t('Question')}</span>
                    <span className={css.sbVal}>
                      {`${currentIndex + 1} ${t('of')} ${totalQuestions}`}
                    </span>
                </div>
                
                <div className={css.sbRow}>
                    <span className={css.sbLabel}>{t('Result')}</span>
                    <span className={css.sbValGreen}>
                        {`${correctCount} ${t('of')} ${answeredCount}`}
                    </span>
                </div>
                
                {quizType && (
                    <div className={css.sbRow}>
                        <span className={css.sbLabel}>{t('Type')}</span>
                        <span className={css.sbVal}>{quizType}</span>
                    </div>
                )}
                
                <div className={css.sbQs}>
                    {dots}
                </div>
            </div>
            
            <div className={css.sbCard}>
                <div className={css.sbTitle}>{t('Lesson steps')}</div>
                <div className={css.sbSteps}>
                    <div className={css.sbStepDone}>
                        <CheckIcon style={{ width: 15, height: 15 }} />
                        {t('Video')} — {t('completed')}
                    </div>
                    <div className={css.sbStepDone}>
                        <CheckIcon style={{ width: 15, height: 15 }} />
                        {t('Words')} — {t('completed')}
                    </div>
                    <div className={css.sbStepActive}>
                        <ClockIcon style={{ width: 15, height: 15 }} />
                        {t('Quiz')} — {t('in progress')}
                    </div>
                    <div className={css.sbStepNext}>
                        <MicIcon style={{ width: 15, height: 15 }} />
                        {t('Speaking')} — {t('next')}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuizSidebar;